import React from "react";
import { MdCheckCircle } from "react-icons/md";
import { t } from "i18next";

const SuccessIcon = () => <MdCheckCircle className="w-16 h-16 text-success" />;

export const getSuccessDialogProps = (props) => ({
  className: "border-t-4 border-success-hover",
  titleClassName: "text-success-hover",
  textClassName: "text-success",
  image: props.image || <SuccessIcon />,
  buttons: props.buttons || [
    {
      text: t("general.buttons.confirm"),
      variant: "success",
    },
  ],
  ...props,
});

export default SuccessIcon;
